import React, { useEffect, useRef, useState } from 'react';

import { LanguageCode, Option, RoutePath, useScreenWidthLessThen } from 'src/shared';
import Header from 'src/widgets/ui/header/header';
import { MOBILE_VIEW_BREAKPOINT_PX } from 'src/widgets/ui/header/header.contst';

type Props = {
  title: string;
  links: { to: RoutePath; label: string }[];
  langCode: LanguageCode;
  langOptions: Option[];
  langMobileOptions: Option[];
  onCurrentLangChange: (code: string) => void;
  logoLinkPath: RoutePath;
};

const HeaderLogicLayer: React.FC<Props> = ({
  title,
  links,
  langCode,
  langOptions,
  langMobileOptions,
  onCurrentLangChange,
  logoLinkPath,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const isMobile = useScreenWidthLessThen(MOBILE_VIEW_BREAKPOINT_PX);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!isMenuOpen) {
        return;
      }
      if (menuRef?.current && !menuRef?.current?.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  const closeMenu = () => setIsMenuOpen(false);

  const toggleMenu = (): void => {
    setIsMenuOpen(open => !open);
  };

  return (
    <Header
      title={title}
      links={links}
      langCode={langCode}
      langOptions={isMobile ? langMobileOptions : langOptions}
      onCurrentLangChange={onCurrentLangChange}
      menuRef={menuRef}
      isMenuOpen={isMenuOpen}
      toggleMenu={toggleMenu}
      closeMenu={closeMenu}
      logoLinkPath={logoLinkPath}
    />
  );
};

export default HeaderLogicLayer;
